'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _templateObject = _taggedTemplateLiteral(['\n  width: 100%;\n  display: flex;\n  flex-direction: ', ';\n  align-items: center;\n  justify-content: space-between;\n  padding: 20px;\n  border-style: none none ', ' none;\n  border-width: 1px;\n  border-color: ', ';\n'], ['\n  width: 100%;\n  display: flex;\n  flex-direction: ', ';\n  align-items: center;\n  justify-content: space-between;\n  padding: 20px;\n  border-style: none none ', ' none;\n  border-width: 1px;\n  border-color: ', ';\n']),
    _templateObject2 = _taggedTemplateLiteral(['\n  display: flex;\n  flex-direction: ', ';\n  align-items: center;\n'], ['\n  display: flex;\n  flex-direction: ', ';\n  align-items: center;\n']),
    _templateObject3 = _taggedTemplateLiteral(['\n  margin: ', ';\n'], ['\n  margin: ', ';\n']),
    _templateObject4 = _taggedTemplateLiteral(['\n  flex: 1;\n  text-align: ', ';\n'], ['\n  flex: 1;\n  text-align: ', ';\n']),
    _templateObject5 = _taggedTemplateLiteral(['\n  width: 100%;\n  margin-top: ', 'px;\n'], ['\n  width: 100%;\n  margin-top: ', 'px;\n']),
    _templateObject6 = _taggedTemplateLiteral(['\n  padding: ', ';\n  cursor: pointer;\n'], ['\n  padding: ', ';\n  cursor: pointer;\n']),
    _templateObject7 = _taggedTemplateLiteral(['\n  margin: ', ';\n  font-size: 18px;\n  color: ', ';\n'], ['\n  margin: ', ';\n  font-size: 18px;\n  color: ', ';\n']);

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _styledComponents = require('styled-components');

var _styledComponents2 = _interopRequireDefault(_styledComponents);

var _Avatar = require('../../Avatar/Avatar');

var _Avatar2 = _interopRequireDefault(_Avatar);

var _Button = require('../../Button/Button');

var _Button2 = _interopRequireDefault(_Button);

var _Heading = require('../../Heading/Heading');

var _Heading2 = _interopRequireDefault(_Heading);

var _Icon = require('../../Icon/Icon');

var _Icon2 = _interopRequireDefault(_Icon);

var _Tooltip = require('../../Tooltip/Tooltip');

var _Tooltip2 = _interopRequireDefault(_Tooltip);

var _colors = require('../../../libs/colors');

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}

function _taggedTemplateLiteral(strings, raw) {
  return Object.freeze(Object.defineProperties(strings, {
    raw: {
      value: Object.freeze(raw)
    }
  }));
} // Components
// Styles


var Container = _styledComponents2.default.div(_templateObject, function (_ref) {
  var center = _ref.center;
  return center ? 'column' : 'row';
}, function (_ref2) {
  var border = _ref2.border;
  return border ? 'solid' : 'none';
}, _colors.grey);

var Flex = _styledComponents2.default.div(_templateObject2, function (_ref3) {
  var center = _ref3.center;
  return center ? 'column' : 'row';
});

var AvatarContainer = _styledComponents2.default.div(_templateObject3, function (_ref4) {
  var center = _ref4.center;
  return center ? '0px 0px 15px 0px' : '0px 15px 0px 0px';
});

var Title = _styledComponents2.default.div(_templateObject4, function (_ref5) {
  var center = _ref5.center;
  return center ? 'center' : 'left';
});

var SubTitle = _styledComponents2.default.div(_templateObject5, function (_ref6) {
  var margin = _ref6.margin;
  return margin ? 3 : 0;
});

var HeadButton = _styledComponents2.default.div(_templateObject6, function (_ref7) {
  var center = _ref7.center;
  return center ? '10px 5px 0px 5px' : '0px 0px 0px 10px';
});

var HeadIcon = _styledComponents2.default.div(_templateObject7, function (_ref8) {
  var center = _ref8.center;
  return center ? '0px 0px 15px 0px' : '0px 15px 0px 0px';
}, _colors.darkGrey);

var CardHeader = function CardHeader(_ref9) {
  var title = _ref9.title,
      subtitle = _ref9.subtitle,
      avatar = _ref9.avatar,
      centerHeader = _ref9.centerHeader,
      headerActions = _ref9.headerActions,
      border = _ref9.border,
      icon = _ref9.icon,
      foldable = _ref9.foldable,
      visible = _ref9.visible,
      toggleVisibility = _ref9.toggleVisibility;
  return !title && !subtitle && !avatar && !headerActions.length ? null : _react2.default.createElement(Container, {
    center: centerHeader,
    border: border
  }, _react2.default.createElement(Flex, {
    center: centerHeader
  }, avatar && _react2.default.createElement(AvatarContainer, {
    center: centerHeader
  }, _react2.default.createElement(_Avatar2.default, {
    avatar: avatar.label,
    theme: avatar.color || 'red',
    size: centerHeader ? 'large' : 'normal'
  })), !avatar && icon && _react2.default.createElement(HeadIcon, {
    center: centerHeader
  }, _react2.default.createElement(_Icon2.default, {
    icon: icon
  })), (title || subtitle) && _react2.default.createElement(Title, {
    center: centerHeader
  }, title && _react2.default.createElement(_Heading2.default, {
    size: '5'
  }, title), subtitle && _react2.default.createElement(SubTitle, {
    margin: title !== null
  }, _react2.default.createElement(_Heading2.default, {
    size: '6',
    grey: true
  }, subtitle)))), _react2.default.createElement(Flex, null, headerActions.map(function (action, index) {
    return _react2.default.createElement(HeadButton, {
      key: index,
      center: centerHeader,
      onClick: action.onClick
    }, _react2.default.createElement(_Tooltip2.default, {
      text: action.tooltip || null,
      position: 'bottom',
      block: true
    }, _react2.default.createElement(_Button2.default, {
      icon: action.icon,
      size: 'small',
      theme: 'grey',
      disabled: action.disabled ? true : false,
      loading: action.loading ? true : false,
      outline: true
    })));
  }), foldable && _react2.default.createElement(HeadButton, {
    center: centerHeader,
    onClick: toggleVisibility
  }, _react2.default.createElement(_Tooltip2.default, {
    text: visible ? 'Hide' : 'Show',
    position: 'bottom',
    block: true
  }, _react2.default.createElement(_Button2.default, {
    icon: visible ? 'shrink' : 'arrowsalt',
    size: 'small',
    theme: 'grey',
    outline: true
  })))));
};

CardHeader.propTypes = {
  title: _propTypes2.default.node,
  subtitle: _propTypes2.default.node,
  avatar: _propTypes2.default.object,
  centerHeader: _propTypes2.default.bool,
  headerActions: _propTypes2.default.array,
  icon: _propTypes2.default.string,
  foldable: _propTypes2.default.bool,
  visible: _propTypes2.default.bool,
  toggleVisibility: _propTypes2.default.func
};
exports.default = CardHeader;